import labelsMixin from '../../mixins/labels.js';

var script = {
  name: 'PendoRadioGroup',
  mixins: [labelsMixin],
  inject: {
    $formItem: {
      default: ''
    }
  },
  provide() {
    return {
      $radioGroup: this
    };
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      default: null
    },
    button: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: 'vertical',
      validator: direction => ['vertical', 'horizontal'].includes(direction)
    },
    size: {
      type: String,
      default: null,
      validator: size => ['mini', 'small', 'medium'].includes(size)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: undefined
    }
  },
  computed: {
    ariaLabelledBy() {
      if (this.$formItem) {
        return this.$formItem.labelId;
      }
      if (this.topLabel) {
        return `pendo-radio-group__label--top-${this._uid}`;
      }
      if (this.bottomLabel) {
        return `pendo-radio-group__label--bottom-${this._uid}`;
      }
      return undefined;
    },
    groupName() {
      return this.name || `pendo-radio-group-${this._uid}`;
    },
    radioGroupClass() {
      return ['pendo-radio-group', {
        'is-button-group': this.button,
        'is-vertical': this.direction === 'vertical' && !this.button,
        'is-horizontal': this.direction === 'horizontal' || this.button
      }];
    }
  },
  watch: {
    value(value) {
      if (this.$formItem) {
        this.$formItem.onFieldChange(value);
      }
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-radio-group.vue2.js.map
